import Shophouses1 from '../Shophouse/Shophouse (1).webp'
import Shophouses2 from '../Shophouse/Shophouse (2).webp'
import Shophouses3 from '../Shophouse/Shophouse (3).webp'
import Shophouses4 from '../Shophouse/Shophouse (4).webp'

const Shophousesimages =[
Shophouses1,Shophouses2,Shophouses3,Shophouses4
]

export default Shophousesimages;